import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { Button, Popup, Field, Form, Toast } from 'vant'
import 'vant/lib/index.css'
import './assets/css/global.css'

const app = createApp(App)

// 注册Vant组件
app.use(Button)
app.use(Popup)
app.use(Field)
app.use(Form)
app.use(Toast)
app.use(router)

app.mount('#app')